import $ from 'jquery'
// 'spin',
// 'jquerySpin'

export const padding = {
  xs: 40,
  sm: 40,
  md: 100,
  lg: 100,
  xl: 100,
  ds: 100,
}
export const breakpoints = {
  xs: 420,
  sm: 768,
  md: 992,
  lg: 1200,
  xl: 1600,
  ds: 1920,
}
export const timeout = {}
export const spin = {
  lines: 13,
  length: 1,
  width: 5,
  radius: 6,
  scale: 1,
  corners: 1,
  color: '#FFF',
  opacity: 0.25,
  rotate: 0,
  direction: 1,
  speed: 1,
  trail: 60,
  fps: 20,
  zIndex: 2e9,
  className: 'spinner',
  top: '50%',
  // left: '0',
  left: '50%',
  shadow: false,
  hwaccel: false,
  position: 'absolute',
}
export const getBreakpoint = () => {
  var $window = $(window)

  if ($window.width() < breakpoints.xs) {
    return 'xs'
  } else if ($window.width() < breakpoints.sm) {
    return 'sm'
  } else if ($window.width() < breakpoints.md) {
    return 'md'
  } else if ($window.width() < breakpoints.lg) {
    return 'lg'
  } else if ($window.width() < breakpoints.xl) {
    return 'xl'
  } else if ($window.width() < breakpoints.ds) {
    return 'ds'
  }
}
